import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-09a05e38")

_pushScopeId("data-v-09a05e38")
const _hoisted_1 = {
  id: "tags-view-container",
  class: "tags-view-container"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ScrollPane = _resolveComponent("ScrollPane")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ScrollPane, {
      ref: "scrollPaneRef",
      class: "tags-view-wrapper",
      onScroll: _ctx.handleScroll
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.visitedViews, (tag) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            ref: "tag",
            key: tag.path,
            class: [_ctx.isActive(tag) ? 'active' : '', "tags-view-item"],
            to: { path: tag.path, query: tag.query, fullPath: tag.fullPath },
            tag: "span",
            onMouseup: _withModifiers(($event: any) => (!_ctx.isAffix(tag) ? _ctx.closeSelectedTag(tag) : ''), ["middle"]),
            onContextmenu: _withModifiers(($event: any) => (_ctx.openMenu(tag, $event)), ["prevent"])
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("route." + tag.meta.title)) + " ", 1),
              (!_ctx.isAffix(tag))
                ? (_openBlock(), _createBlock("span", {
                    key: 0,
                    class: "el-icon-close",
                    onClick: _withModifiers(($event: any) => (_ctx.closeSelectedTag(tag)), ["prevent","stop"])
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["class", "to", "onMouseup", "onContextmenu"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onScroll"]),
    _withDirectives(_createVNode("ul", {
      style: { left: _ctx.left + 'px', top: _ctx.top + 'px' },
      class: "contextmenu"
    }, [
      _createVNode("li", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshSelectedTag(_ctx.selectedTag)))
      }, _toDisplayString(_ctx.t("tagsView.refresh")), 1),
      (!_ctx.isAffix(_ctx.selectedTag))
        ? (_openBlock(), _createBlock("li", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeSelectedTag(_ctx.selectedTag)))
          }, _toDisplayString(_ctx.t("tagsView.close")), 1))
        : _createCommentVNode("", true),
      _createVNode("li", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeOthersTags && _ctx.closeOthersTags(...args)))
      }, _toDisplayString(_ctx.t("tagsView.closeOthers")), 1),
      _createVNode("li", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeAllTags(_ctx.selectedTag)))
      }, _toDisplayString(_ctx.t("tagsView.closeAll")), 1)
    ], 4), [
      [_vShow, _ctx.visible]
    ])
  ]))
})